//src/app/features/services/addService/index.tsx
import MainWizardSteps from 'app/features/questionnaires/components/MainWizardSteps';
import StepWizard from 'react-step-wizard';
import AddServicesStepOne from './step-one';
import AddServicesStepTwo from './step-two';
import { useSearchParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useGetServicesQuery } from 'app/services/payments/services';
import { useAddCartItemServiceMutation } from 'app/services/payments/cart';
import { useGetUserBusinessesQuery } from 'app/services/user';
import BusinessSelectModal from './BusinessSelectModal';
import { Service } from 'app/services/responseTypes';

const AddServies = () => {
  const [searchParams] = useSearchParams();
  const serviceId = searchParams.get('service_id');
  const businessId = searchParams.get('business_id');
  const autoCheckout = searchParams.get('checkout') === 'true';

  const shouldRedirectToCheckout =
    serviceId ||
    JSON.parse(sessionStorage.getItem('shouldRedirectToCheckout') || 'false');
  const initialStep = shouldRedirectToCheckout ? 2 : 1;
  sessionStorage.setItem('shouldRedirectToCheckout', JSON.stringify(false));

  const { data: services } = useGetServicesQuery();
  const { data: businesses } = useGetUserBusinessesQuery();
  const [hasAdded, setHasAdded] = useState(false);
  const [addCartItem] = useAddCartItemServiceMutation();
  const [showModal, setShowModal] = useState(false);
  const [targetService, setTargetService] = useState<Service | null>(null);

  useEffect(() => {
    if (serviceId && services && businesses && !hasAdded) {
      const service = services.find((s) => s.id === Number(serviceId));
      if (service) {
        if (businessId) {
          addCartItem({
            cart_item: {
              product_id: service.id,
              price_id: service.prices[0].id,
              business_id: Number(businessId),
            },
          })
            .unwrap()
            .then(() => {
              setHasAdded(true);
              if (autoCheckout) {
                sessionStorage.setItem('openAgreementOnLoad', 'true');
              }
            });
        } else {
          setTargetService(service);
          setShowModal(true);
        }
      }
    }
  }, [
    serviceId,
    businessId,
    services,
    businesses,
    hasAdded,
    addCartItem,
    autoCheckout,
  ]);

  const handleSelectBusiness = (businessId: number | null) => {
    if (!targetService) return;
    const param = businessId === null ? 'null' : businessId;
    const url = `/dashboard/services/add-service?service_id=${targetService.id}&business_id=${param}&checkout=${autoCheckout}`;
    window.location.href = url;
  };

  const steps = ['Choose your Service', 'Payment and Checkout'];
  return (
    <div className="p-4">
      <StepWizard
        isLazyMount
        className="wizard z-0"
        initialStep={initialStep}
        nav={<MainWizardSteps steps={steps} />}
      >
        <AddServicesStepOne />
        <AddServicesStepTwo />
      </StepWizard>
      {showModal && targetService && businesses && (
        <BusinessSelectModal
          service={targetService}
          businesses={[
            { name: 'Personal', id: null },
            ...businesses.map((b) => ({ name: b.name, id: b.id })),
          ]}
          onSelect={handleSelectBusiness}
          onClose={() => setShowModal(false)}
        />
      )}
    </div>
  );
};

export default AddServies;
